export default __webpack_public_path__ + "static/media/avatar_ali3.696c7f9d.mp3";